import { defineStore } from 'pinia';

export const useDrawer = defineStore('drawer', () => {
  const state: Ref<DrawerState> = ref({});

  const isOpen = computed(() => !!state.value?.isOpen || false);

  function open(options: DrawerOptions): void {
    state.value.component = options.component;
    state.value.props = options.props;
    state.value.listeners = options.listeners;
    state.value.isOpen = true;
  }

  function close(): void {
    state.value = {};
  }

  return { state, isOpen, open, close };
});

export interface DrawerState {
  component?: Component;
  props?: Record<string, any>;
  listeners?: Record<string, (payload?: any) => any>;
  isOpen?: boolean;
}

export interface DrawerOptions {
  component?: Component;
  props?: Record<string, any>;
  listeners?: Record<string, (payload?: any) => any>;
}
